import styled from 'styled-components';
import { getDateFromArray } from '../../../../lib/date.helpers';

const DateDisplayContainer = styled.span`
  ${({ theme }) => theme.typographyRebrand.body.md}
`;

const DateDisplayPreText = styled.span`
  font-weight: var(--typography-font-weight-bold);
`;

const invalidDateErrorMsg =
  "One or more of the strings passed to the DateDisplay component is not in a format that can be used with the Date() constructor.";

/**
 *
 * Displays the earliest date by default. To display the latest date, use showLatest = true
 *
 * @param {Date[] | String[]} dates An array of either Date objects, or strings that can be used with the Date() constructor
 * @param {String} [preText] Text displayed before the date
 * @param {String} [postText] Text displayed after the date
 * @param {String[]} [classes] An array of CSS classes that will be applied to the root <span> element
 * @param {Object} [styles] A style object that will be applied to the root <span> element
 * @param {String} [dateFormat] The format in which the date should display https://momentjs.com/docs/#/displaying/format/
 * @param {Boolean} [showLatest] if true, shows the latest date instead of the earliest
 * @param {String} [preTextClasses] CSS classes that will be applied to the preText
 * @param {Object} [preTextStyle] a style object that will be applied to the preText
 * @param {String} [postTextClasses] CSS classes that will be applied to the postText
 * @param {Object} [postTextStyle] a style object that will be applied to the postText
 *
 */

const DateDisplay = ({
  dates,
  preText,
  postText,
  dateFormat,
  showLatest,
  className,
  locale,
}) => {
  const displayDate = getDateFromArray(dates, dateFormat, showLatest, locale);

  if (displayDate === "Invalid date") {
    console.error(invalidDateErrorMsg);
    return <span></span>;
  }

  return (
    <DateDisplayContainer className={className}>
      { preText && (
        <DateDisplayPreText className={className}>
          {preText + " "}
        </DateDisplayPreText>
      )}
      {displayDate + " "}
      { postText && (
        <span className={className}>
          {postText}
        </span>)
      }
    </DateDisplayContainer>
  );
};

export default DateDisplay;
